import React from "react";
import Frame from "../shell/Frame";
import Meta from "../shell/Meta";
import Caps from "../parts/Caps";
import Invite from "../parts/Invite";

const Services = () => (
  <Frame>
    <Meta title="Services" description="Eleven engineering disciplines delivered by BTCRuka — software, networking, cloud, security, data and managed IT operations." />

    <section className="svc-hero">
      <div className="shell">
        <div className="crumb">~ <span className="sep">/</span> services</div>
        <span className="eyebrow">Capabilities</span>
        <h1>Eleven disciplines under one accountable team.</h1>
        <p className="lede">
          Each discipline can be engaged on its own. Most engagements combine four or more — sequenced against where your
          stack is today and what your roadmap actually needs.
        </p>
      </div>
    </section>

    <section className="band">
      <div className="shell">
        <Caps />
      </div>
    </section>

    <Invite />
  </Frame>
);

export default Services;
